module.exports = __webpack_public_path__ + "static/media/sunmi_t1.82857a2f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/pricing/sunmi_t1.png
 ** module id = 655
 ** module chunks = 0
 **/